<template>
  <div class="freeze-loading" v-if="visible">
    <div class="freeze-loading-content">
      <a-spin> <a-icon slot="indicator" type="loading" style="font-size: 24px" spin /> </a-spin
      ><br />
      <span>{{ show === true ? `${$t('com_table_loading')}...` : show }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = this.show;
  },
  watch: {
    show(val) {
      this.visible = !!val;
    },
    visible(val) {
      this.$emit('update:show', val);
    },
  },
};
</script>
<style lang="less" scoped>
.freeze-loading {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.5);
  text-align: center;
  z-index: 99999;
  color: #1890ff;

  .freeze-loading-content {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    text-align: center;
    margin: 0 0 0 -100px;
    span {
      display: inline-block;
      padding-top: 10px;
      font-size: 14px;
    }
  }
}
</style>
